import React, { Component } from 'react';
import { observer } from 'mobx-react';

import CreditCardDashboardStore from 'js/stores/pages/AdminDashboardPage/CreditCardDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Search from '../../DashPanel/Search';
import Title from '../../DashPanel/Title';
import DropMenu from '../../DashPanel/DropMenu';
import Controls from '../../DashPanel/Controls';

import Link from './Link';
import GotoItem from './GotoItem';
import Date from './Date';
import NotFound from './NotFound';
import Image from './Image';
import User from './User';
import Label from './Label';

@observer
export default class Dashboard extends Component {
  creditCardDashboard = CreditCardDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.creditCardDashboard.load();
  }

  componentDidUpdate() {
    this.creditCardDashboard.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.creditCardDashboard.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Credit cards</Title>
          <Controls>
            <Search model={this.creditCardDashboard} options={{ name: 'Name' }} />
            <Pagination model={this.creditCardDashboard} />
          </Controls>
        </Header>

        <Content>
          {this.creditCardDashboard.isLoading ? (
            <LoadingSpinner />
          ) : this.creditCardDashboard.credit_cards.length ? (
            <div>
              {this.creditCardDashboard.credit_cards.map(credit_card => (
                <Link to={`credit_card/${credit_card.id}`} key={credit_card.id}>
                  <Image src={`/images/payment-icons/${credit_card.credit_card_type}.png`} />
                  <Date>{credit_card.created_at}</Date>
                  <User>{credit_card.user_name || 'Unknown name'}</User>
                  <Label>
                    <div>{credit_card.credit_card}</div>
                  </Label>
                  <GotoItem />
                </Link>
              ))}
            </div>
          ) : (
            <NotFound>No credit cards found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
